import { render, staticRenderFns } from "./message-test-number-input.vue?vue&type=template&id=16315c52&scoped=true"
import script from "./message-test-number-input.vue?vue&type=script&lang=js"
export * from "./message-test-number-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16315c52",
  null
  
)

export default component.exports